export class BaseApi {
    constructor(options, eventBus) {
        this.options = options;
        this.eventBus = eventBus;
        this.setup();
    }
}